module.exports = __webpack_public_path__ + "static/media/project-img7.9d5fbf12.png";